import { enUS } from 'date-fns/locale';

export default {
	props: {
		locale: {
			type: Object,
			default: () => enUS
		}
	},
	methods: {
		getDayValues(width) {
			const dayArray = [];

			for (let index = 0; index < 7; index++) {
				dayArray.push(
					this.locale.localize.day(index, {
						width: width
					})
				);
			}

			return dayArray;
		},
		getMonthValues(width) {
			const monthArray = [];

			for (let index = 0; index < 12; index++) {
				monthArray.push(
					this.locale.localize.month(index, {
						width: width
					})
				);
			}

			return monthArray;
		},
		getQuarterValues(width) {
			const monthArray = [];

			for (let index = 1; index <= 4; index++) {
				monthArray.push(
					this.locale.localize.quarter(index, {
						width: width
					})
				);
			}

			return monthArray;
		}
	}
};
